import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-157e8998"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "tList",
  class: "bg-dark shadow-2xl z-10 border-t-2 border-bgDark text-gray-50 w-72 overflow-auto text-center absolute inset-y-0 left-0 transform -translate-x-full transition duration-200 ease-in-out md:relative md:translate-x-0"
}
const _hoisted_2 = ["value", "selected"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-3" }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" New Session ")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "list-none text-md text-left ml-16 mt-2"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pr-3 font-medium" }, "Ao5", -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pr-3 font-medium" }, "Mo3", -1))
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pr-3 font-medium" }, "Ao12", -1))
const _hoisted_16 = { key: 3 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pr-3 font-medium" }, "Ao50", -1))
const _hoisted_18 = { key: 4 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pr-3 font-medium" }, "Ao100", -1))
const _hoisted_20 = { key: 5 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pr-3 font-medium" }, "Ao1000", -1))
const _hoisted_22 = {
  key: 3,
  class: "text-center font-body mt-3"
}
const _hoisted_23 = { class: "pl-3 font-bold" }
const _hoisted_24 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.allSessions.length > 0)
      ? (_openBlock(), _createElementBlock("select", {
          key: 0,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSessionChange($event))),
          class: "bg-bgDark text-gray-50 px-4 py-2 my-2 rounded-md focus:outline-none"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allSessions, (s, idx) => {
            return (_openBlock(), _createElementBlock("option", {
              key: idx,
              value: s.doc.name,
              selected: s.doc == _ctx.currentSession
            }, _toDisplayString(s.doc.name), 9, _hoisted_2))
          }), 128))
        ], 32))
      : _createCommentVNode("", true),
    (_ctx.allSessions.length > 0)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ToggleSessionDeleteModal())),
          class: "ml-2 my-3 btn-sm bg-red-600 hover:text-red-600 hover:bg-gray-100 transition duration-150"
        }, _hoisted_4))
      : _createCommentVNode("", true),
    _hoisted_5,
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ToggleModal())),
      class: "my-4 btn bg-secondary hover:text-secondary hover:bg-gray-100 transition duration-150"
    }, _hoisted_8),
    (_ctx.currentSession)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
          (_ctx.currentSession.solveList.length >= 5)
            ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                _hoisted_11,
                _createTextVNode(" " + _toDisplayString(_ctx.getAverage(5)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentSession.solveList.length >= 3)
            ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                _hoisted_13,
                _createTextVNode(" " + _toDisplayString(_ctx.getMean(3)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentSession.solveList.length >= 12)
            ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                _hoisted_15,
                _createTextVNode(" " + _toDisplayString(_ctx.getAverage(12)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentSession.solveList.length >= 50)
            ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                _hoisted_17,
                _createTextVNode(" " + _toDisplayString(_ctx.getAverage(50)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentSession.solveList.length >= 100)
            ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                _hoisted_19,
                _createTextVNode(" " + _toDisplayString(_ctx.getAverage(100)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentSession.solveList.length >= 1000)
            ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                _hoisted_21,
                _createTextVNode(" " + _toDisplayString(_ctx.getAverage(1000)), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentSession)
      ? (_openBlock(), _createElementBlock("ol", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentSession.solveList.sort((a,b) => new Date(b.timestamp) - new Date(a.timestamp)), (solve, idx) => {
            return (_openBlock(), _createElementBlock("li", { key: idx }, [
              _createTextVNode(_toDisplayString(idx + 1) + ". ", 1),
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.parseTime(solve.time, solve.penalty)), 1),
              _createElementVNode("i", {
                onClick: ($event: any) => (_ctx.ToggleSolveModal(solve)),
                class: "text-primary ml-2 px-1.5 py-1.5 rounded cursor-pointer hover:bg-gray-900 transition duration-100 fas fa-pen"
              }, null, 8, _hoisted_24)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}